export default __webpack_public_path__ + "static/students-1-cacb736ad5c4a8a0ca061cb42e802e51.jpg";